import { useEffect } from "react";
import app from "nystem";

const MapRecord = ({ model, view, value }) => {
  useEffect(() => {
    let timer = false;

    const saveData = async () => {
      const { latitude, longitude, accuracy } = await app.event(
        "mapsDevicePos"
      );

      await app.database[view.contentType].save({
        data: {
          [model.id]: [latitude, longitude],
          accuracy,
          [model.recIdField]: view.baseView.value._id,
        },
      });
      if (timer === "exited") return;
      timer = setTimeout(saveData, model.interval * 1000);
    };
    saveData();

    return () => {
      if (timer) clearTimeout(timer);
      timer = "exited";
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default MapRecord;
